jQuery( document ).ready(function( $ ) {

        var referenceElement = document.querySelector('.js-delivery-info');
        var onPopper = document.querySelector('.js-delivery-info-popper');
        $(".js-delivery-info").click(function() {
          $(".js-delivery-info-popper").toggle();
          let popper = new Popper(referenceElement, onPopper, {
            placement: 'top',
          });
        });

        $(".js-delivery-close").click(function() {
          $(".js-delivery-info-popper").toggle();
        });

      let textLimit = 30;
      if ($(window).width() > 767) {
          textLimit = 30;
      } else {
          textLimit = 15;
      }

      $('.left-td').each(function () {
          if ($(this).text().length > textLimit) {
              $(this).addClass('crop');
              $(this).addClass('long-text');
              $(this).click(function () {
                  $(this).toggleClass('crop');
              });
          }
      });
  
      $('.right-td').each(function () {
          if ($(this).text().length > textLimit) {
              $(this).addClass('crop');
              $(this).addClass('long-text');
              $(this).click(function () {
                  $(this).toggleClass('crop');
              });
          }
      });
 
    
      $('[data-toggle="tooltip"]').hover(
        function() {

          let strValue = $( this ).attr('data-original-title');
          $( this ).before('<span id="ctcTooltip" class="ctc-tooltip">'+strValue+'</span>');      

        }, function() {
          $("#ctcTooltip").remove();
        }
      );




      
    // Function for collection Gallery
    $('body').on('click', '.gallery-image-container', function (e) {
    
      console.log(e);
      console.log(e.target.nodeName);
      console.log(e.target.classList);
      e.preventDefault();

      if($(e.target).hasClass('gallery-grid-view-item-img')){
          console.log('IMAGE CLICK')

          if ($(window).width() > 768) {

              $(e.target).parent().parent().find('.gallery-grid-view-item').hide();
              $(e.target).parent().addClass('active');
              $(e.target).parent().show();
              $(e.target).parent().parent().find('.gallery-image-container_back').show();                    
          }

           // hide and show right arrows
           if($(e.target).parent().parent().find('.gallery-grid-view-item.active').next('.gallery-grid-view-item').length >= 1){
                $(e.target).parent().parent().find('.gallery-image-container_right').show();
            } else{
                $(e.target).parent().parent().find('.gallery-image-container_right').hide();
            }
 
            // Hide and show left arrows
            if($(e.target).parent().parent().find('.gallery-grid-view-item.active').prev('.gallery-grid-view-item').length >= 1){
                $(e.target).parent().parent().find('.gallery-image-container_left').show();
            } else{
                $(e.target).parent().parent().find('.gallery-image-container_left').hide();
            }

      } else if($(e.target).hasClass('gallery-image-container_back')){
          $(e.target).hide();
          $(e.target).parent().find('.gallery-grid-view-item').removeClass('active');
          $(e.target).parent().find('.gallery-grid-view-item').hide();
          $(e.target).parent().find('.gallery-grid-view-item').slice(0, 8).each(function(index) {
              $(this).show();
          });

      } else if($(e.target).hasClass('gallery-image-container_right')){  
          // RIGHT ARROW CLICK
          console.log('arrow right click');

          if( $(e.target).parent().find('.gallery-grid-view-item.active').length >= 1 ){
              if($(e.target).parent().find('.gallery-grid-view-item.active').next('.gallery-grid-view-item').length >= 1){
                  $(e.target).parent().find('.gallery-grid-view-item.active').next('.gallery-grid-view-item').addClass('active');
                  $(e.target).parent().find('.gallery-grid-view-item.active').last().show();
                  $(e.target).parent().find('.gallery-grid-view-item.active').first().hide();
                  $(e.target).parent().find('.gallery-grid-view-item.active').first().removeClass('active');

                  $(e.target).parent().find('.gallery-image-container_left').show();

                  // hide and show right arrows
                  if($(e.target).parent().parent().find('.gallery-grid-view-item.active').next('.gallery-grid-view-item').length >= 1){
                      $(e.target).parent().parent().find('.gallery-image-container_right').show();
                  } else{
                      $(e.target).parent().parent().find('.gallery-image-container_right').hide();
                  }

                  // Hide and show left arrows
                  if($(e.target).parent().parent().find('.gallery-grid-view-item.active').prev('.gallery-grid-view-item').length >= 1){
                      $(e.target).parent().parent().find('.gallery-image-container_left').show();
                  } else{
                      $(e.target).parent().parent().find('.gallery-image-container_left').hide();
                  }

              }
          } else{

              let firstIndex = Number($(e.target).parent().find('.gallery-grid-view-item:visible:first').index() - 4);
              console.log('First element index ' + firstIndex );

              let itemSize = $(e.target).parent().find('.gallery-grid-view-item').length;
              console.log('itemSize '+itemSize);
              console.log('last item '+ Number(firstIndex+16));

              if(firstIndex+8 < itemSize){
                  $(e.target).parent().find('.gallery-grid-view-item').hide();

                  $(e.target).parent().find('.gallery-grid-view-item').slice(Number(firstIndex+8), Number(firstIndex+16)).each(function(index) {
                      $(this).show();
                  });

                  $(e.target).parent().find('.gallery-image-container_left').show();
              }
          }

      } else if($(e.target).hasClass('gallery-image-container_left')){ 
          // LEFT ARROW CLICK 
          console.log('arrow left click');

          if( $(e.target).parent().find('.gallery-grid-view-item.active').length >= 1 ){
              if($(e.target).parent().find('.gallery-grid-view-item.active').prev('.gallery-grid-view-item').length >= 1){
                  $(e.target).parent().find('.gallery-grid-view-item.active').prev('.gallery-grid-view-item').addClass('active');
                  $(e.target).parent().find('.gallery-grid-view-item.active').first().show();
                  $(e.target).parent().find('.gallery-grid-view-item.active').last().hide();
                  $(e.target).parent().find('.gallery-grid-view-item.active').last().removeClass('active');

                  // hide and show right arrows
                  if($(e.target).parent().parent().find('.gallery-grid-view-item.active').next('.gallery-grid-view-item').length >= 1){
                      $(e.target).parent().parent().find('.gallery-image-container_right').show();
                  } else{
                      $(e.target).parent().parent().find('.gallery-image-container_right').hide();
                  }

                  // Hide and show left arrows
                  if($(e.target).parent().parent().find('.gallery-grid-view-item.active').prev('.gallery-grid-view-item').length >= 1){
                      $(e.target).parent().parent().find('.gallery-image-container_left').show();
                  } else{
                      $(e.target).parent().parent().find('.gallery-image-container_left').hide();
                  }

              }
          } else {

              let firstIndex = Number($(e.target).parent().find('.gallery-grid-view-item:visible:first').index() - 4);
              console.log('First element index ' + firstIndex );
              let num1 = firstIndex - 8;                
              let num2 = firstIndex;
              console.log(num1,num2);
              if(num1 >= 0){
                  $(e.target).parent().find('.gallery-grid-view-item').hide();
                  $(e.target).parent().find('.gallery-grid-view-item').slice(num1,num2).each(function(index) {
                      $(this).show();
                  });            
                  $(e.target).parent().find('.gallery-image-container_right').show();            
              }
          }

      } else if($(e.target).hasClass('gallery-image-container_close')){
          if($(this).hasClass('active')){
              //$(this).find(".gallery-image-container_view").remove();
              $(this).removeClass('active');


              if ($(window).width() <= 768) {
                  $('body').css('overflow','');

                  console.log('screen is less than 768px on close!');

                  $(this).find('.gallery-grid-view-item.active').removeClass('active');
              }

          }
      } else {
                        
          if($(this).hasClass('active')){
         
              // $(this).removeClass('active');
              // if ($(window).width() <= 768) {
              //     $('body').css('overflow','');

              //     console.log('screen is less than 768px on close!');

              //     $(this).find('.gallery-grid-view-item.active').removeClass('active');
              // }

          } else{
              
              $(".gallery-image-container").removeClass("active");
                             
              $(this).addClass('active');

              if ($(window).width() > 768) {
                  setTimeout(function(){
                      $('html, body').animate({
                          scrollTop: $(".gallery-image-container.active .gallery-image-container_view").offset().top - 150
                      }, 300);
                  }, 300);
              }   

              console.log('Scroll in to View');  
              
              
              
              if ($(window).width() <= 768) {
                  $('body').css('overflow','hidden');
                  console.log('screen is less than 768px');
                  $(this).find('.gallery-grid-view-item').hide();
                  $(this).find('.gallery-grid-view-item').first().show();
                  $(this).find('.gallery-grid-view-item').first().addClass('active');
                  // hide and show right arrows
                  if($(this).find('.gallery-grid-view-item.active').next('.gallery-grid-view-item').length >= 1){
                      $(this).find('.gallery-image-container_right').show();
                  } else{
                      $(this).find('.gallery-image-container_right').hide();
                  }

                  // hide and show left arrows
                  if($(this).find('.gallery-grid-view-item.active').prev('.gallery-grid-view-item').length >= 1){
                    $(this).find('.gallery-image-container_left').show();
                  } else{
                    $(this).find('.gallery-image-container_left').hide();
                  }
              }

                // // hide and show right arrows
                // if($(e.target).parent().parent().find('.gallery-grid-view-item.active').next('.gallery-grid-view-item').length >= 1){
                //     $(e.target).parent().parent().find('.gallery-image-container_right').show();
                // } else{
                //     $(e.target).parent().parent().find('.gallery-image-container_right').hide();
                // }

                // // Hide and show left arrows
                // if($(e.target).parent().parent().find('.gallery-grid-view-item.active').prev('.gallery-grid-view-item').length >= 1){
                //     $(e.target).parent().parent().find('.gallery-image-container_left').show();
                // } else{
                //     $(e.target).parent().parent().find('.gallery-image-container_left').hide();
                // }

              if($(this).find('.gallery-grid-view-item').length > 8){
                  $(this).find('.gallery-image-container_right').show();
              }
          }
      }
  });

     

});